<template>
    <div class="card-container">
        <common-top-form :model="formModel" :show="false" :submitService="submitService"
                         :submitData="submitData" @success="onSuccess">
            <select-organs v-model="formModel.simpleTatId"></select-organs>
            <el-form-item label="申请人电话">
                <el-input v-model="formModel.Mobile" maxlength="11" placeholder="请输入申请人电话"></el-input>
            </el-form-item>
            <el-form-item label="申请人身份证">
                <el-input v-model="formModel.idCard" maxlength="50" placeholder="请输入申请人身份证"></el-input>
            </el-form-item>
            <el-form-item label="申请人姓名">
                <el-input v-model="formModel.realName" maxlength="50" placeholder="请输入申请人姓名"></el-input>
            </el-form-item>
            <el-form-item label="操作类型">
                <el-select v-model="formModel.orderStatus">
                    <el-option
                        v-for="item in orderStatus"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="操作日期">
                <el-date-picker
                    v-model="formModel.time"
                    type="daterange"
                    range-separator="至"
                    value-format="yyyy-MM-dd"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
        </common-top-form>
        <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
            <el-table-column type="index" label="序号" min-width="50"></el-table-column>
            <el-table-column prop="merName" label="申请人姓名" min-width="130" show-overflow-tooltip></el-table-column>
            <el-table-column prop="merMobile" label="申请人电话" min-width="130" show-overflow-tooltip></el-table-column>
            <el-table-column prop="merIdCard" label="申请人身份证" min-width="130" show-overflow-tooltip></el-table-column>
            <el-table-column prop="orderNo" label="订单号" min-width="130" show-overflow-tooltip></el-table-column>
            <el-table-column prop="bankName" label="信用卡名称" min-width="130" show-overflow-tooltip></el-table-column>
            <el-table-column prop="cardAmount" label="奖励金额（元）" min-width="130" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{toDoubleThousands(scope.row.cardAmount)}}
                </template>
            </el-table-column>
            <el-table-column prop="orderStatus" label="订单状态" min-width="130" :formatter="formatTranTypee" show-overflow-tooltip></el-table-column>
            <el-table-column prop="updateTime" label="操作日期" min-width="130" show-overflow-tooltip></el-table-column>
            <el-table-column prop="errorMessage" label="备注" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作"  min-width="160">
                <template slot-scope="scope">
                    <el-button type="text" @click="handleSettle(scope.row)" v-if="scope.row.orderStatus == 1">结算</el-button>
                    <p  v-else>--</p>
                </template>
            </el-table-column>
        </common-table>
    </div>
</template>

<script>
    import CommonTopForm from 'components/common/CommonTopForm'
    import CommonTable from 'components/common/CommonTable'
    import SelectOrgans from 'components/business/SelectOrgans'

    import OrganService from 'service/OrganService'
    import ChannelService from 'service/ChannelService'
    import ChannelRateService from 'service/ChannelRateService'
    import OrganRateService from 'service/OrganRateService'
    import TimeRange from 'service/constant/TimeRange'
    import {loadMixin, dialogMixin, validatorsMixin} from "mixin";
    import {mapGetters} from 'vuex'

    export default {
        name: "resultonlinecard",
        data() {
            return {
                formModel: {
                    simpleTatId: '',
                    Mobile: '',
                    idCard: '',
                    realName: '',
                    orderStatus: '',
                    time: TimeRange.dayRange,
                },
                orderStatus:[{
                    value: '',
                    label: '全部'
                }, {
                    value:'0',
                    label:'处理中'
                }, {
                    value:'1',
                    label:'已完成'
                }, {
                    value:'2',
                    label:'已拒绝'
                }, {
                    value:'3',
                    label:'无效单'
                }, {
                    value:'4',
                    label:'已结算'
                }],
                tableData: [],
                submitService: OrganRateService.cardOrderList,
                page: {},
                isPage: false,
            }
        },
        mixins: [loadMixin, dialogMixin, validatorsMixin],
        components: {
            CommonTopForm,
            CommonTable,
            SelectOrgans,
        },
        mounted() {
            this.page = this.$refs.commonTable.page;

            this.getList();
        },
        computed: {
            submitData() {
                if (this.formModel.time == null || this.formModel.time == '') {
                    this.formModel.time = [];
                }
                this.params = {
                    simpleTatId: this.formModel.simpleTatId,
                    Mobile: this.formModel.Mobile.trim(),
                    idCard: this.formModel.idCard.trim(),
                    realName: this.formModel.realName.trim(),
                    orderStatus: this.formModel.orderStatus,
                    startTime: this.formModel.time[0],
                    endTime: this.formModel.time[1],
                    current: this.isPage ? this.page.currentPage : 1,
                    size: this.page.pageSize,
                };
                if (this.formModel.time.length == 0) {
                    delete this.params.startTime;
                    delete this.params.endTime;
                }
                return this.params;
            },
            ...mapGetters(['userId'])
        },
        methods: {
            formatTranTypee(row, column, cellValue){
                let value='';
                this.orderStatus.forEach(item => {
                    if (item.value == cellValue) {
                        value = item.label;
                    }
                });
                return value ? value : '--';
            },
            getPage() {
                this.isPage = true;
                this.getList();
            },
            getList() {
                this.doLoad(this.submitService, this.submitData, res => {
                    this.doCheck(res, res => {
                        this.onSuccess(res);
                        this.isPage = false;

                    });
                }, '信息获取失败')
            },
            onSuccess(data) {
                this.doCheck(data, res => {
                    const result = res.contents;
                    this.tableData = result.rows;

                    this.page.currentPage = result.current;
                    this.page.total = result.total;
                    this.page.pageSize = result.size;
                })
            },
            doSettle(item){
                this.doLoad(OrganRateService.cardCloseOrder, {
                    id: item.id,
                    userId: this.userId
                }, res => {
                    this.doCheck(res, res => {
                        const result = res.contents;
                        this.showSuccess(result.optMsg);
                        this.getList();
                    });
                }, '信息获取失败')
            },
            handleSettle(item){
                this.showConfirm('确定对该条数据进行结算操作吗？').then(() => {
                    this.doSettle(item)
                }).catch(() => {
                });


            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/page/FinanceManage/ResultOnlineCard.vue